export default "__VITE_ASSET__Fg907cfaBf941t5yTg6kag__"